export default "__VITE_ASSET__BGD67Db0__"